import { createContext, useContext } from 'react';
import useAiFieldGeneration from 'routes/Documentation/DocumentForm/utils/useAiFieldGeneration';

export type AiFieldGenerationApi = ReturnType<typeof useAiFieldGeneration>;

const AiFieldGenerationContext = createContext<AiFieldGenerationApi | null>(
  null,
);

export const AiFieldGenerationProvider = AiFieldGenerationContext.Provider;

export const useSharedAiFieldGeneration = () =>
  useContext(AiFieldGenerationContext);
